require("./bootstrap");
require("./jquery");
require("./datatables");
require("./modules");
require("select2");
require("select2/dist/js/i18n/pt-BR");